import { useContext } from 'react';

import { HeaderContext, IHeaderContext } from './header.context';

export const useHeaderNavigation = (): IHeaderContext => useContext(HeaderContext);
